import { apiSlice } from '../../api/apiSlice';
import { DashboardParams } from '../dashboardTypes';
import { serializeQueryParams } from '../index';
import { SimsInfoResponse } from './simsInfoApiSliceTypes';

const simsInfoApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getSimsInfo: builder.query<SimsInfoResponse, DashboardParams>({
            query: (params) => ({
                url: `/dashboard/sims?${serializeQueryParams(params)}`,
                method: 'GET',
                headers: {
                    'Accept-Language': params.acceptLanguage ?? 'en',
                },
            }),
        }),
    }),
    overrideExisting: true,
});

export const { useGetSimsInfoQuery, useLazyGetSimsInfoQuery } =
    simsInfoApiSlice;
